import classNames from 'classnames';

import { DownloadButton } from '@/pages/UserAccount/UserRequests/ui';

import { ServiceCode } from '@/shared/types';

import { useArtifactLoader } from '@/hooks/useArtifactLoader';

import { UserRequestPart } from '@/api/types';

import api from '@/api';

import { Status } from '../../Status/Status';
import { BaseServiceRowCardProps, ServiceRowCardVariant } from '../model';
import { BaseCard } from '../model/BaseCard/BaseCard';

import { Row, RowRenderer } from './RowRenderer';

export interface UserRequestPartCardProps extends BaseServiceRowCardProps {
  variant: ServiceRowCardVariant.USER_REQUEST_PART;
  userRequestPart: UserRequestPart;
  serviceCode: ServiceCode;
}

export const UserRequestPartCard: React.FC<UserRequestPartCardProps> = ({ userRequestPart, serviceCode, variant }) => {
  const { isArtifactLoading, downloadArtifact } = useArtifactLoader((artifactType) =>
    api.downloadUserRequestPartArtifact(userRequestPart.id, artifactType),
  );

  const rows: Row[] = [
    {
      label: 'Модель',
      value: userRequestPart.modelName,
      dataTestId: 'user-request-part-model',
    },
    {
      label: 'Тип',
      value: userRequestPart.type,
      dataTestId: 'user-request-part-type',
    },
  ];

  return (
    <BaseCard
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__status-wrapper">
          <Status status={userRequestPart.status_decorator || userRequestPart.status} />
        </div>
      }
      body={
        <div className="service-row-card__meta-wrapper">
          <RowRenderer rows={rows} />
        </div>
      }
      actions={(userRequestPart.artifacts || []).map((artifactType) => (
        <DownloadButton
          key={artifactType}
          type={artifactType}
          serviceCode={serviceCode}
          disabled={isArtifactLoading}
          iconName="download"
          onClick={async (): Promise<void> => downloadArtifact(artifactType, serviceCode)}
        />
      ))}
    />
  );
};
